/**
 * Pre-configured API client instances
 *
 * Singleton instances for common API clients.
 */

import { ApiClient } from './api-client';

/**
 * Default API client for internal API calls.
 * - BaseUrl: '' (relative URLs)
 * - Logging: enabled
 * - Auto-idempotency: enabled
 */
export const apiClient = new ApiClient();

/**
 * GitHub API client for GitHub REST API calls.
 * - BaseUrl: https://api.github.com
 * - Logging: enabled
 * - Auto-idempotency: disabled (GitHub doesn't use our idempotency pattern)
 */
export const githubApiClient = new ApiClient(
  'https://api.github.com',
  true,
  false
);

/**
 * GitHub OAuth client for token exchange.
 * - BaseUrl: https://github.com
 * - Logging: enabled
 * - Auto-idempotency: disabled
 */
export const githubOAuthClient = new ApiClient(
  'https://github.com',
  true,
  false
);
